<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="rejectComment" />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <SoftwareFields
          :software="software"
          :readonly="readonly"
          :editor-ready="loadComplete"
          :allow-image-upload="!readonly"
          :image-upload-created="Boolean(operationId)"
          :image-upload-path="imageUploadPath"
          @update="updateField"
        />

        <UserFormActions
          v-if="!readonly"
          :form_name_text="$t('forms.titles.' + formName)"
          :form_name="formName"
          :refForm="$refs.form"
          :saveform_trigger="false"
          object_type="software"
          :data="processData"
          :state="state"
          class="text-center mt-6"
          @change-state="changeState"
        />
        <div v-else class="text-center mt-6">
          <v-btn text @click="$router.go(-1)">
            <v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import UserFormActions from "@/components/action_buttons/UserFormActions";
import RejectCommentLayout from "@/components/layouts/RejectCommentLayout";
import SoftwareFields from "@/components/software/SoftwareFields.vue";
import changeState from "@/mixins/changeState";
import {
  createDefaultSoftware,
  normalizeSoftware,
  serializeSoftware
} from "@/utils/software";

export default {
  name: "SoftwareFormEditor",
  components: { RejectCommentLayout, SoftwareFields, UserFormActions },
  mixins: [changeState],
  props: {
    formName: {
      type: String,
      required: true
    },
    modification: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    software: createDefaultSoftware(),
    objectId: null,
    operationId: null,
    state: "",
    rejectComment: "",
    loadComplete: false
  }),
  computed: {
    imageUploadPath() {
      return this.operationId
        ? `${this.$store.state.endpoint}/user/moderatedOperations/software/${this.operationId}`
        : "";
    },
    readonly() {
      return Boolean(this.$route.meta.readOnly);
    },
    isStoredForm() {
      return this.$route.params.id > -1 && !this.$route.meta.update;
    },
    processData() {
      return {
        title: this.software.name || "",
        object_type: "software",
        form_name: this.formName,
        object_id: this.objectId,
        data: {
          user: {
            software: serializeSoftware(this.software)
          }
        }
      };
    }
  },
  created() {
    if (this.isStoredForm) {
      this.getStoredForm();
    } else if (this.modification) {
      this.getSoftware();
    } else {
      this.loadComplete = true;
    }
  },
  methods: {
    updateField(field, value) {
      this.$set(this.software, field, value);
    },
    getStoredForm() {
      axios
        .get(`${this.$store.state.endpoint}/user/moderatedOperations/software/${this.$route.params.id}`)
        .then(response => {
          this.operationId = response.data.id;
          this.objectId = response.data.object_id;
          this.software = normalizeSoftware(response.data.data.user.software);
          this.software.image_squared = response.data.image_squared || "";
          this.software.image_horizontal = response.data.image_horizontal || "";
          this.software.id = this.objectId;
          this.state = response.data.state;
          this.rejectComment = response.data.reject_comment || "";
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.loadComplete = true;
        });
    },
    getSoftware() {
      axios
        .get(`${this.$store.state.endpoint}/user/software/${this.$route.params.id}`)
        .then(response => {
          this.software = normalizeSoftware(response.data);
          this.objectId = response.data.id;
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.loadComplete = true;
        });
    }
  }
};
</script>
